import { BASVURU_ANAYA_GORE_BASVURU_LISTESI } from "../constants/requestUrls";
import { postRequest } from "../request";

const basvuruDetailLists = (BasvuruAnaId) => {
    const data = {BasvuruAnaId}
    return postRequest({url:BASVURU_ANAYA_GORE_BASVURU_LISTESI,data});
}

export default basvuruDetailLists;